/// <reference types="@welldone-software/why-did-you-render" />

// Import Habla styles early so that local style can override them if needed
import '@dixa/lib-shared-habla/style.css';

import { ErrorBoundaryContext } from '@dixa/lib-shared-habla';
import { Sentry, sentryInit } from 'lib-shared-sentry';
// eslint-disable-next-line no-restricted-imports
import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as UnstableHistoryRouter } from 'react-router-dom';

import { App } from 'app/app';
import { patchAgainstGoogleTranslateInterferingWithReactDOM } from 'app/utils/googleTranslateWorkaround';
import { setStoreAxios } from 'app/utils/verifyPermissions';
import { history, store } from 'bootstrap.store';
import { setStoreElevio } from 'components/conversation/components/integrations/elevio/src/utils/apis/graphql/baseQuery/elevio/elevioStore';
import { i18n } from 'utils/i18n';

import AudioManager from './assets/app/utils/audioManager';

// eslint-disable-next-line no-restricted-imports
import 'assets/styles/less/main.less';

if (process.env.NODE_ENV === 'development') {
  // We only import wdyr package on development, hence need the var require.
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React);
}

i18n.init();
sentryInit(SENTRY_ENV, VERSION);

// Run before rendering the app, but after Sentry is initialized.
patchAgainstGoogleTranslateInterferingWithReactDOM('warning');

// Sets the store for the audio manager.
AudioManager.setStore(store);
// Sets the store for the Elevio Datahub
setStoreElevio(store);
// Sets the store for axios verify permissions interceptor
setStoreAxios(store);

/**
 * Handles Logging the error to Sentry.
 *
 * @param error The error from the error boundary.
 */
const handleError = (error: Error) => {
  Sentry.captureException(error);
};

const root = createRoot(document.getElementById('app')!);

root.render(
  <Provider store={store}>
    <ErrorBoundaryContext.Provider value={{ onError: handleError }}>
      <DndProvider backend={HTML5Backend}>
        <UnstableHistoryRouter history={history as any} basename={BASEPATH}>
          <App />
        </UnstableHistoryRouter>
      </DndProvider>
    </ErrorBoundaryContext.Provider>
  </Provider>,
);
